import React, { useEffect, useState } from 'react';
import { Routes, Route, useLocation, Navigate, useNavigate } from "react-router-dom";
import { Spin } from 'antd';
import 'bootstrap/dist/css/bootstrap.min.css';
import HomePage from "./home/home";
import WebScraperCustomPPI from "./features/web-scraper/web_scraper_custom_ppi";
import Signin from './features/SignIn/Signin';
import { UserProvider, useUser } from './context/UserContext';
import Account from './features/Account/Account';
import { auth } from './services/firebase';
import Signup from './features/SignUp/Signup';
import ForgotPassword from './features/ForgotPassword/ForgotPassword';
import Research from './features/research/research';
import PrivacyPolicy from './features/PrivacyPolicy/PrivacyPolicy';
import TermsOfService from './features/TermsOfService/TermsOfService';
import CookiePolicy from './features/CookiePolicy/CookiePolicy';
import VinHomePage from './home/VinHomePage';

// A wrapper for <Route> that redirects to the login
// screen if you're not yet authenticated or if auth is still
// loading.
const ProtectedRoute = ({ children }: { children: JSX.Element }) => {
  const { user, isLoading } = useUser();

  if (isLoading) {
    return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}><Spin size="large" /></div>;
  }

  if (!user) {
    // Redirect them to the /signin page, but save the current location they were
    // trying to go to. This allows us to send them along to that page after they
    // log in, which is a nicer user experience than dropping them off on the home page.
    // return <Navigate to={`/signin?redirectTo=${encodeURIComponent(location.pathname + location.search)}`} replace />;
  }

  return children;
};

// The main App component is now much cleaner.
function App() {
  const [, setUser] = useState<any>(null);
  const navigate = useNavigate();
  const location = useLocation(); // To get the current URL's search params

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      setUser(user);

      // If not authenticated and not already on the signin page, redirect
      if (!user) {
        const currentPath = location.pathname + location.search;

        // Prevent recursive redirects by checking if we're already on /signin
        if (currentPath.startsWith("/create-report") || currentPath.startsWith("/account") || currentPath.startsWith("/research")) {
          navigate(`/signup?redirectTo=${encodeURIComponent(currentPath)}`);
        }
      }
    });

    return unsubscribe;
  }, [navigate, location]);
  return (
    <UserProvider>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/vin" element={<VinHomePage />} />
        <Route path="/signin" element={<Signin />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route
          path="/create-report"
          element={<ProtectedRoute><WebScraperCustomPPI /></ProtectedRoute>}
        />
        <Route
          path="/account"
          element={<ProtectedRoute><Account /></ProtectedRoute>}
        />
        <Route
          path="/research"
          element={<Navigate to="/research/details" replace />}
        />
        <Route path="/research/:step" element={<ProtectedRoute><Research /></ProtectedRoute>} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/cookie-policy" element={<CookiePolicy />} />
      </Routes>
    </UserProvider>
  );
}

export default App;